export const setHookSize = (self, { outer_r, inner_r }) => {
  const hook_empty_path_el = self._getHookEmptyPathElThrowable();
  const hook_path_el = self._getHookPathElThrowable();
  const common_d = [
    `M ${-outer_r} 0`,
    `A ${outer_r} ${outer_r} 180 1 1 ${outer_r} 0`,
    `A ${outer_r} ${outer_r} 180 1 1 ${-outer_r} 0`,
  ];
  const empty_path_d = [...common_d, `Z`].join(" ");
  const path_d = [
    ...common_d,
    `M ${-inner_r} 0`,
    `A ${inner_r} ${inner_r} 180 1 0 ${inner_r} 0`,
    `A ${inner_r} ${inner_r} 180 1 0 ${-inner_r} 0`,
    `Z`,
  ].join(" ");
  hook_empty_path_el.setAttributeNS(null, "d", empty_path_d);
  hook_path_el.setAttributeNS(null, "d", path_d);
};
